export default stats => {
  if (stats.length === 0) return {};
  if (stats.length === 1) {
    return {
      bidRequestsVal: Number(stats[0].bidRequests),
      responseTimeVal: Number(stats[0].responseTime),
      aprVal: Number(stats[0].apr),
    };
  }
  const bidRequestsVal = Number(stats[0].bidRequests);
  const responseTimeVal = Number(stats[0].responseTime);
  const aprVal = Number(stats[0].apr);

  const compResponseTimeVal = Number(stats[1].responseTime);
  const compAprVal = Number(stats[1].apr);

  const responseTimeDiff =
    responseTimeVal < compResponseTimeVal
      ? compResponseTimeVal - responseTimeVal
      : responseTimeVal - compResponseTimeVal;
  const isResponseBetter = responseTimeVal < compResponseTimeVal;

  const aprDiff = aprVal < compAprVal ? compAprVal - aprVal : aprVal - compAprVal;
  const isAprBetter = aprVal < compAprVal;

  return {
    bidRequestsVal,
    responseTimeVal,
    compAprVal,
    aprVal,
    compResponseTimeVal,
    responseTimeDiff,
    isResponseBetter,
    aprDiff,
    isAprBetter,
  };
};



// WEBPACK FOOTER //
// ./src/utils/loanOfficerDashboardHelper.js